export default __webpack_public_path__ + "static/media/sound.610622ce920d00d8be3b99dddb6e1434.svg";